import PropTypes from 'prop-types';
import LiveVideoCounter from './components/live-video-counter';
import LiveVideoStatusUpdater from './components/live-video-status-updater';
import { isStreamingLive } from '@wix/wix-vod-shared/src/common/ui-selectors/video/live';
import { isPreviewOrEditorMode } from 'widget/components/preview-prompt/preview-prompt';

const LiveVideosUpdater = ({ videoItem, eventEmitter, channelId }) => (
  isStreamingLive(videoItem) && !isPreviewOrEditorMode() ? (
    <div>
      <LiveVideoCounter eventEmitter={eventEmitter}
                        videoItem={videoItem} />
      <LiveVideoStatusUpdater eventEmitter={eventEmitter}
                              videoItem={videoItem}
                              channelId={channelId} />
    </div>
) : null);

LiveVideosUpdater.propTypes = {
  videoItem: PropTypes.object,
  eventEmitter: PropTypes.object,
  channelId: PropTypes.string,
};

export default LiveVideosUpdater;



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/containers/live-video-updaters/live-video-updaters.js